import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: {
        title: '',
        metaTags: [
          {
            name: 'description',
            content: 'Roomi'
          },
          {
            property: 'og:desccription',
            content: 'Roomi'
          }
        ]
      }
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('../views/About.vue'),
      meta: {
        title: 'About',
        metaTags: [
          {
            name: 'description',
            content: 'lorem ipsum'
          },
          {
            propery: 'og:description',
            content: 'lorem ipsum'
          }
        ]
      }
    },

    {
      path: '/spye-series',
      name: 'SPYIE SERIES',
      component: () => import('../views/SpyeSeries.vue'),
      meta: {
        title: 'SPYIE SERIES from Roomi',
        metaTags: [
          {
            name: 'description',
            content: 'lorem ipsum'
          },
          {
            propery: 'og:description',
            content: 'lorem ipsum'
          }
        ]
      }
    },
    {
      path: '/spye',
      name: 'SPYIE',
      component: () => import('../views/Spye.vue'),
      meta: {
        title: 'SPYE from Roomi',
        metaTags: [
          {
            name: 'description',
            content: 'lorem ipsum'
          },
          {
            propery: 'og:description',
            content: 'lorem ipsum'
          }
        ]
      }
    },
    {
      path: '/spyeminii',
      name: 'SPYIEMINII',
      component: () => import('../views/SpyeMiniI.vue'),
      meta: {
        title: 'SPYE MINI I from Roomi',
        metaTags: [
          {
            name: 'description',
            content: 'lorem ipsum'
          },
          {
            propery: 'og:description',
            content: 'lorem ipsum'
          }
        ]
      }
    },
    {
      path: '/spyeminiii',
      name: 'SPYIEMINIIII',
      component: () => import('../views/SpyeMiniII.vue'),
      meta: {
        title: 'SPYE MINI II from Roomi',
        metaTags: [
          {
            name: 'description',
            content: 'lorem ipsum'
          },
          {
            propery: 'og:description',
            content: 'lorem ipsum'
          }
        ]
      }
    },
    {
      path: '/lumio',
      name: 'LUMIO',
      component: () => import('../views/Lumio.vue'),
      meta: {
        title: 'Lumio from Roomi',
        metaTags: []
      }
    },
    {
      path: '/support',
      name: 'Tech Support',
      component: () => import('../views/Support.vue'),
      meta: {
        title: 'Tech Support',
        // title: 'Roomi Tech Support',
        metaTags: []
      }
    },
    {
      path: '/privacy/bahasa',
      name: 'BAHASA',
      component: () => import('../views/Bahasa.vue'),
      meta: {
        title: 'Kebijakan Privasi',
        metaTags: []
      }
    },
    {
      path: '/privacy/english',
      name: 'ENGLISH',
      component: () => import('../views/English.vue'),
      meta: {
        title: 'Privacy Police',
        metaTags: []
      }
    },
    {
      path: '/terms/bahasa',
      name: 'TERMSBAHASA',
      component: () => import('../views/TermsBahasa.vue'),
      meta: {
        title: 'Terms Of Use',
        metaTags: []
      }
    },
    {
      path: '/download',
      name: 'Download Roomi App',
      component: () => import('../views/download/Download.vue'),
      meta: {
        title: 'Download File',
        // title: 'Download Roomi App',
        metaTags: []
      },
    },
    {
      path: '/download/:seo_url',
      name: "Detail Download",
      component: () => import('../views/download/Detail.vue'),
      meta: {
        title: 'Download File',
        // title: 'Download Roomi App',
        metaTags: []
      },
    },
    // {
    //   path: '/cart',
    //   name: 'Cart',
    //   component: () => import('../views/Cart.vue'),
    //   meta: {
    //     title: 'Cart',
    //     metaTags: []
    //   }
    // },
    {
      path: '/service_center',
      name: 'Service_center',
      component: () => import('../views/Service_center.vue'),
      meta: {
        title: 'Service Center',
        metaTags: [],
      }
    },
    {
      path: '/store',
      name: 'Store',
      component: () => import('../views/Store.vue'),
      meta: {
        title: 'Store',
        metaTags: [],
      }
    },
    {
      path: '/store_roomi',
      name: 'Store_roomi',
      component: () => import('../views/Store_roomi.vue'),
      meta: {
        title: 'Store_roomi',
        metaTags: [],
      }
    },
    {
      path: '/blog',
      name: 'Blog',
      component: () => import('../views/Blog.vue'),
      meta: {
        title: 'Blog',
        metaTags: [],
      }
    },
    // {
    //   path: '/product/:id',
    //   name: 'Product Detail',
    //   component: () => import('../views/product/Id.vue'),
    //   meta: {
    //     title: '',
    //     metaTags: [
    //       {
    //         name: 'description',
    //         content: 'lorem ipsum'
    //       },
    //       {
    //         propery: 'og:description',
    //         content: 'lorem ipsum'
    //       }
    //     ]
    //   },
    // },
    
    {
      path: '/product',
      name: 'all-product',
      component: () => import('../views/product/All_product.vue'),
      meta: {
        title: 'Product',
        metaTags: [
          {
            name: 'description',
            content: 'product of Roomi'
          },
          {
            propery: 'og:description',
            content: 'product of Roomi'
          }
        ]
      },
    },
    {
      path: '/collections',
      name: 'collections',
      component: () => import('../views/Collections.vue'),
      meta: {
        title: 'Collections',
        metaTags: [],
      }
    },
    {
      path: '/collections',
      name: 'collections',
      component: () => import('../views/Collections.vue'),
      meta: {
        title: 'Collections',
        metaTags: [],
      }
    },
    {
      path: '/profile',
      name: 'My Profile',
      component: () => import('../views/profile/Index.vue'),
      meta: {
        title: 'My Profile',
        metaTags: [
          {
            name: 'description',
            content: 'My Profile Roomi'
          },
          {
            propery: 'og:description',
            content: 'My Profile Roomi'
          }
        ]
      }
    },
    {
      path: '/profile/transaction',
      name: 'Transaction',
      component: () => import('../views/profile/Transaction.vue'),
      meta: {
        title: 'Transaction',
        metaTags: [
          {
            name: 'description',
            content: 'Transaction Roomi'
          },
          {
            propery: 'og:description',
            content: 'Transaction Roomi'
          }
        ]
      },
      alias: ['/transaction']
    },
    {
      path: '/profile/transaction/detail',
      name: 'Transaction Detail',
      component: () => import('../views/profile/TransactionDetail.vue'),
      alias: ['/transaction/detail']
    },
    {
      path: '/profile/verification_phone',
      name: 'Verification Phone',
      component: () => import('../views/profile/VerifyPhone.vue'),
      meta: {
        title: 'Verification Phone',
        metaTags: [
          {
            name: 'description',
            content: 'Verification Phone'
          },
          {
            propery: 'og:description',
            content: 'Verification Phone'
          }
        ]
      }
    },
    {
      path: '/search',
      name: 'SearchPage',
      component: () => import('../views/Search.vue'),
      meta: {
        title: "Search Product",
        metaTags: [
          {
            name: 'description',
            content: 'Search Product'
          },
          {
            property: "og:description",
            content: "Search Product"
          }
        ]
      }
    },
    {
      path: '/e-garansi',
      name: 'EGaransi',
      component: () => import('../views/e-guarantee/EGuarantee.vue'),
      meta: {
        title: "E-Garansi"
      }
    },
    {
      path: '/e-garansi/cek',
      name: 'CekEGaransi',
      component: () => import('../views/e-guarantee/Check.vue'),
      meta: {
        title: "E-Garansi"
      }
    },
    {
      path: '/e-garansi/print',
      name: 'PrintEGaransi',
      component: () => import('../views/e-guarantee/Print.vue'),
      meta: {
        title: "E-Garansi"
      }
    },
    {
      path: '/page-product/:url',
      name: "CustomProductPage",
      component: () => import('../views/CustomProductPage.vue')
    },
    {
      path: '/:categoryid/:productid',
      name: 'product-detail',
      component: () => import('../views/product/Id.vue'),
      props: (route) => ({ categoryid: route.params.categoryid, productid: route.params.productid }),
      meta: {
        title: 'Product',
        metaTags: [],
      }
    },
    {
      path: '/event',
      name: 'Event',
      component: () => import('../views/Event.vue'),
      meta: {
        title: 'Event',
        metaTags: [
          {
            name: 'description',
            content: 'Event Roomi'
          },
          {
            propery: 'og:description',
            content: 'Event Roomi'
          }
        ]
      }
    },
    {
      path: '*',
      name: 'Not Found Page',
      component: () => import('../views/404.vue'),
      meta: {
        title: 'Not Found'
      }
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve({
          x: 0,
          y: 0
        })
      }, 300)
    })
  }
})

router.afterEach((to, from) => {
  Vue.nextTick(() => {
    const DEFAULT_TITLE = 'Roomi';
    document.title = DEFAULT_TITLE;
    // document.title += to.meta.title ? ' - ' + to.meta.title : '';
    if (to.meta.title) {
      document.title = to.meta.title + ' - ' + DEFAULT_TITLE;
    } else {
      document.title = DEFAULT_TITLE;
    }
  });
})

export default router